// For now this is just duplicated in both places, eventually we should only use this version

import {useEffect, useState} from "react";

class AssetHelperClass {
    baseUrl? : string
    assetManifest: Record<string, string>
    useHashedAssets?: boolean
    initialized: boolean
    constructor () {
        this.assetManifest = {}
        this.initialized = false
    }

    async ensureProperties () {
        if(this.initialized) {
            return;
        }
        const response = await fetch('/assets/manifest')
        const parsedResponse = await response.json()
        this.useHashedAssets = parsedResponse.useHashedAssets
        this.assetManifest = parsedResponse.assetManifest
        this.baseUrl = parsedResponse.baseUrl
        this.initialized = true
    }

    syncPath(asset : string) {
        let realBaseUrl = "/"
        if(this.baseUrl != null) {
            realBaseUrl = this.baseUrl
        }
        if(!this.useHashedAssets) {
            return realBaseUrl + asset + '?_magic_=_ASSET_HELPER_'
        }
        const hashedUrl = this.assetManifest[asset];
        if(!hashedUrl) {
            throw `Asset ${asset} not found!`
        }
        return realBaseUrl + hashedUrl
    }

    async path(asset : string) {
        await this.ensureProperties()
        return this.syncPath(asset)
    }
}

const AssetHelper = new AssetHelperClass();

export default AssetHelper

export function useAsset(name: string): string
export function useAsset(name?: string): string | undefined
export function useAsset(name?: string) {
    const [assetPath, setAssetPath] = useState(name ? AssetHelper.syncPath(name) : undefined);

    useEffect(() => {
        async function setPath() {
            setAssetPath(name ? await AssetHelper.path(name) : undefined);
        }
        setPath()
    }, [name])
    return assetPath
}